import { Link } from "react-router-dom";
import TableActions, { ViewAction, OnlyView, ViewCommentAction } from "../components/TableActions";
import { useDeleteBranch } from "../hooks/branches/useDelete";
import { useDeleteRole } from "../hooks/roles/useDelete";
import { useDeleteUser } from "../hooks/users/useDelete";
import { useDeactivateForm } from "../hooks/forms/useDelete";
import { useDeleteFormCategory } from "../hooks/formCategories/useDelete";
import UpdateBranch from "../forms/update/UpdateBranch";
import UpdateFormCategory from "../forms/update/UpdateFormCategory";
import UpdateRole from "../forms/update/UpdateRole";
import UpdateUser from "../forms/update/UpdateUser";
import * as Yup from "yup";
import BooleanStatus from "../components/BooleanStatus";
import FormRequestStatus from "../components/FormRequestStatus";
import TermsAction from "../components/TermsAction";

// DUMMY DATA
export const data = [
  {
    id: 1,
    name: "Beetlejuice",
    approvalLevels: 2,
    customerId: 10000,
  },
  {
    id: 2,
    name: "Ghostbusters",
    approvalLevels: 2,
    customerId: 23000,
  },
];

// TABLE COLUMNS
export const columns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Name</span>,
    selector: (row) => row.name,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Receipt Prefix</span>,
    selector: (row) => row.receiptPrefix,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => row.status,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => (
      <Link to={`/event/${row.id}?name=${row.name}`}>View</Link>
    ),
  },
];

export const roleColumns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Name</span>,
    selector: (row) => row.roleName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => (
      <BooleanStatus _bool={row.status} first={"Inactive"}
        second={"Active"} />
    ),
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Priviledge</span>,
    selector: (row) => row?.privilege?.description,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => (
      <TableActions
        deleteAction={() => useDeleteRole(row.roleId)}
        updateForm={<UpdateRole role={row} />}
        updateTitle="Update Role"
        deleteText={`deactivate ${row.roleName}`}
      />
    ),
  },
];

export const branchColumns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Branch Name</span>,
    selector: (row) => row.branchName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Branch Code</span>,
    selector: (row) => row.branchCode,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => (
      <BooleanStatus
        _bool={row.activeStatus}
        first={"Inactive"}
        second={"Active"}
      />
    ),
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => (
      <TableActions
        deleteAction={() => useDeleteBranch(row.branchId)}
        updateForm={<UpdateBranch branch={row} />}
        updateTitle="Update Branch"
        deleteText={`deactivate ${row.branchName}`}
      />
    ),
  },
];
export const myDeskColumns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Name</span>,
    selector: (row) => row?.formType?.formTypeName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Ticket</span>,
    selector: (row) => row.ticketNumber,
    sortable: true,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Date Filled</span>,
    selector: (row) => new Date(row.dateFilled).toLocaleString(),
    sortable: true,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => (
      <FormRequestStatus completed={row.isCompleted} rejected={row.isRejected} engaged={row.officerId} />
    ),
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => <OnlyView status={row.officerId} id={row.formId} _officerId={row.officerId}/>,
  },
];

export const myHistoryColumns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Name</span>,
    selector: (row) => row?.formType?.formTypeName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Ticket</span>,
    selector: (row) => row.ticketNumber,
    sortable: true,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Date Filled</span>,
    selector: (row) => new Date(row.dateFilled).toLocaleString(),
    sortable: true,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => (
      <FormRequestStatus completed={row.isCompleted} rejected={row.isRejected} engaged={row.officerId} />
    ),
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => <OnlyView history={true} status={row.officerId} id={row.formId} _officerId={row.officerId}/>,
  },
];

export const formCategoryColumns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Category Name</span>,
    selector: (row) => row.categoryName,
   
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => (
      <BooleanStatus
        _bool={row.activeStatus}
        first={"Inactive"}
        second={"Active"}
      />
    ),
   
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Description</span>,
    selector: (row) => row.description ?? "No description",
  },

  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => (
      <TableActions
        deleteAction={() =>
          useDeleteFormCategory(row.id, {
            categoryId: row.categoryId,
            description: row.description,
            categoryName: row.categoryName,
            activeStatus: false,
          })
        }
        updateForm={<UpdateFormCategory formCategory={row} />}
        updateTitle="Update Form Category"
        deleteText={`deactivate ${row.categoryName}`}
      />
    ),
  
  },
];

export const formColumns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Name</span>,
    selector: (row) => row.formTypeName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => (
      <BooleanStatus
        _bool={row.activeStatus}
        first={"Inactive"}
        second={"Active"}
      />
    ),
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Initial Desk</span>,
    selector: (row) => row?.initialDeskNavigation?.roleName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Category</span>,
    selector: (row) => row?.category?.categoryName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => (
      <ViewAction
        id={row.formTypeId}
        name={row.formTypeName}
        deleteAction={() => useDeactivateForm(row.formTypeId)}
        deleteText={`deactivate ${row.formTypeName}`}
      />
    ),
  },
    {
    name: <span className="text-[#888] text-[14px]">T & C</span>,
    selector: (row) => <TermsAction formTypeId={row.formTypeId} />,
  },
];

export const formActionHistoryColumn = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Officer Name</span>,
    selector: (row) => row?.officer?.officerName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Action Name</span>,
    selector: (row) => row?.formAction?.actionName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Date</span>,
    selector: (row) => <div className=" w-[auto] text-left ">{new Date(row?.dateTime).toLocaleString()}</div>,
  },

];

export const formTransitHistoryColumn = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Officer Name</span>,
    selector: (row) => row?.officer?.officerName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Previous Role</span>,
    selector: (row) => row?.sourceRole?.roleName,
  },
   {
    name: <span className={"text-[#888] text-[14px]"}>Destination Role</span>,
    selector: (row) => row?.destinationRole?.roleName,
  },
    {
    name: <span className={"text-[#888] text-[14px]"}>Previous Branch</span>,
    selector: (row) => row?.sourceBranch?.branchName,
  },
   {
    name: <span className={"text-[#888] text-[14px]"}>Destination Branch</span>,
    selector: (row) => row?.destinationBranch?.branchName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Date</span>,
    selector: (row) => <div className=" w-[auto] text-left ">{new Date(row?.dateTimeInserted).toLocaleString()}</div>,
  },

];

export const formCommentColumn = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Messages</span>,
    selector: (row) => <div className=" flex flex-col  items-start mb-4 mt-2 w-[470px] ">
      <p className=" w-full break-all  text-justify !whitespace-normal !break-normal text-[13px] mb-2">{row?.message}</p>
      <span className="text-slate-600 text-[13px]">Officer : {row?.officer?.officerName}</span>
      <span className="text-slate-400 text-[10px]">Date : {new Date(row?.dateTimeInserted).toLocaleString()}</span>
      <div className="flex justify-end  w-full ">
   {/*    <ViewCommentAction
        deleteAction={() => useDeactivateForm(row.formTypeId)}
        deleteText={`deactivate ${row.formTypeName}`}
        /> */}
      </div>
     
    </div>,
  },
  /* {
    name: <span className={"text-[#888] text-[14px]"}>Message</span>,
    selector: (row) => 'row',
  }, */


  //new Date(row.dateFilled).toLocaleString()


];

export const userColumns = [
  {
    name: <span className={"text-[#888] text-[14px]"}>Teller Id</span>,
    selector: (row) => row.tellerId,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Officer Name</span>,
    selector: (row) => <span className="">{row.officerName}</span>,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Email</span>,
    selector: (row) => row.email,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Branch</span>,
    selector: (row) => row.branchName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Role</span>,
    selector: (row) => row.roleName,
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Status</span>,
    selector: (row) => (
      <BooleanStatus
        _bool={row.officerStatus}
        first={"Inactive"}
        second={"Active"}
      />
    ),
  },
  {
    name: <span className={"text-[#888] text-[14px]"}>Actions</span>,
    selector: (row) => (
      <TableActions
        deleteAction={() => useDeleteUser(row.officerId)}
        updateForm={<UpdateUser user={row} />}
        updateTitle="Update User"
        deleteText={`deactivate ${row.officerName}`}
      />
    ),
  },
];

// TABLE STYLES
export const tableCustomStyles = {
  rows: {
    style: {
      minHeight: "60px", // override the row height
      color: "#111",
      fontSize: "14px",
      fontWeight: "400",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px", // override the cell padding for head cells
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px", // override the cell padding for data cells
      paddingRight: "8px",
    },
  },
};

export const tableCustomStylesII = {
  rows: {
    style: {
      minHeight: "60px", // override the row height
      color: "#888",
      fontSize: "14px",
      fontWeight: "400",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px", // override the cell padding for head cells
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px", // override the cell padding for data cells
      paddingRight: "8px",
    },
  },
};

export const formInitialValues = {
  formTypeName: "",
  initialDesk: 0,
  categoryId: 0,
  activeStatus: false,
  description: "",
  formSections: [
    {
      name: "",
      activeStatus: true,
      IsOfficial:false,
      formFields: [
        {
          label: "",
          activeStatus: true,
          isCalculated: false,
          calculationFormula: "",
          calculationFormulaeDependents:"",
          formFieldTypeId: 0,
          required: false,
          formFieldOptions: [],
        },
      ],
    },
  ],
  notes: [],
  roleForms: [
    {
      roleId: 0,
      status: true,
    },
  ],
};

export const formValidationSchema = Yup.object().shape({
  formTypeName: Yup.string().required("Form Name is required"),
  initialDesk: Yup.number().required("Initial Desk is required"),
  activeStatus: Yup.bool(),
  categoryId: Yup.number().required("Category is required"),
  formSections: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string(),
        isOfficial: Yup.bool(),
        formFields: Yup.array().of(
          Yup.object().shape({
            label: Yup.string().required("Required"),
            activeStatus: Yup.bool().required("Required"),
            isCalculated: Yup.bool(),
            calculationFormula: Yup.string(),
            calculationFormulaeDependents: Yup.string(),
            required: Yup.bool().required("Required"),
            formFieldTypeId: Yup.number().required("Required"),
            formFieldOptions: Yup.array().of(
              Yup.object().shape({
                fieldValue: Yup.string().required("Required"),
              })
            ),
          })
        ),
      })
    )
    .required("Must have a section"),
});



export const updateformValidationSchema = Yup.object().shape({
  formTypeName: Yup.string().required("Form Name is required"),
  initialDesk: Yup.number().required("Initial Desk is required"),
  activeStatus: Yup.boolean(),
  categoryId: Yup.number().required("Category is required"),
  formSections: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string(),
        isOfficial: Yup.boolean(),
        formFields: Yup.array().of(
          Yup.object().shape({
            label: Yup.string().required("Required"),
            activeStatus: Yup.boolean().required("Required"),
            isCalculated: Yup.boolean().default(false),
            isImage: Yup.boolean().default(false),
             imageSize: Yup.string()
              .nullable()
              .when("isImage", {
                is: true,
                then: (s) => s.required("Required when field has image"),
                otherwise: (s) => s.nullable().notRequired(),
              }),

            // Only required when isCalculated === true; otherwise allow null/undefined
            calculationFormula: Yup.string()
              .nullable()
              .when("isCalculated", {
                is: true,
                then: (s) => s.required("Required when field is calculated"),
                otherwise: (s) => s.nullable().notRequired(),
              }),

            calculationFormulaeDependents: Yup.string()
              .nullable()
              .when("isCalculated", {
                is: true,
                then: (s) => s.required("Required when field is calculated"),
                otherwise: (s) => s.nullable().notRequired(),
              }),

            required: Yup.boolean().required("Required"),
            formFieldTypeId: Yup.number().required("Required"),

            // Options only need fieldValue when they exist; array itself can be empty
            formFieldOptions: Yup.array().of(
              Yup.object().shape({
                fieldValue: Yup.string().required("Required"),
              })
            ),
          })
        ),
      })
    )
    .required("Must have a section"),
});

